import { useHistory } from 'react-router-dom'

import { Button } from 'common/components'

type ReportNotificationProps = {
  text?: string
  route?: string
}

const ReportNotification = ({ text, route }: ReportNotificationProps) => {
  const history = useHistory()

  return (
    <>
      <div className="flex flex_space_between flex__align_center outer-div mb-8">
        <span className="color-gray-9 text-semi-bold t-reimbursement-amount">{text}</span>

        <Button className="c-white" type="primary" onClick={() => history.push(route)}>
          Download now
        </Button>
      </div>
    </>
  )
}

export default ReportNotification
